import { KatLitFilteredElement, register } from '../../shared/base';
import { KatBlueprintReport } from '.';

/**
 * @component {kat-blueprint-report-overview} KatBlueprintReportOverview Component used to place and filter components within the overview section.
 * @slot default Blueprint content for overview section.
 */
@register(KatBlueprintReport.slotMapping.overview.name)
export class KatBlueprintReportOverview extends KatLitFilteredElement {
  constructor() {
    super(
      KatBlueprintReport.slotMapping.overview.name,
      KatBlueprintReport.slotMapping.overview.allowed
    );
  }
}
